import { instance } from "apis/interceptor";
import { ResponseType } from "apis/meetings/meeting-reservation";
import { IReceiverMember } from "pages/meeting/complain-manager-setting/uis/table-view/person-table-view";
import { TMember } from "types/user.types";

//INFO: 민원 알림 수신자 설정하기
export const setAlarmReceiver = async (memberList: TMember[]): Promise<ResponseType<boolean>> => {
  try {
    const response = await instance.patch(`/meeting-room-complain/alarm-receiver`, {
      memberList: memberList,
    });

    return { success: response.data.result };
  } catch (error) {
    return { success: false };
  }
};

//INFO: 민원 알림 수신자 조회하기
export const getAlarmReceiver = async (): Promise<ResponseType<IReceiverMember[]>> => {
  try {
    const response = await instance.get(`/meeting-room-complain/alarm-receiver`);
    if (response.data) {
      return { success: true, data: response.data };
    } else {
      return { success: false, data: [] };
    }
  } catch (error) {
    return { success: false, data: [] };
  }
};

//INFO: 민원 알림 수신자 삭제하기
export const deleteAlarmReceiver = async (meetingRoomComplainId: string): Promise<ResponseType<boolean>> => {
  try {
    const response = await instance.delete(`/meeting-room-complain/alarm-receiver`, {
      data: {
        id: meetingRoomComplainId,
      },
    });

    return { success: response.data.result };
  } catch (error) {
    return { success: false };
  }
};

//INFO: 민원 알림 채널 변경하기
export const changeAlarmChannel = async (channel: "SLACK" | "EMAIL"): Promise<ResponseType<boolean>> => {
  try {
    const response = await instance.patch(`/meeting-room-complain/alarm-receiver/my-alarm-channel`, {
      hostAlarmChannel: channel,
    });
    return { success: response.data.result, message: "설정이 변경되었습니다." };
  } catch (error: any) {
    if (error.response.status === 409) {
      return { success: false, message: "슬랙 메신저가 설정되지 않았습니다." };
    }
    if (error.response.status === 403) {
      return { success: false, message: "민원 담당자 설정이 되지 않았습니다." };
    } else {
      return { success: false, message: "알림 채널 변경에 실파하였습니다. 다시 시도해주세요." };
    }
  }
};
